
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[userId]",
      function () {
        return require("private-next-pages/profile/[userId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[userId]"])
      });
    }
  